"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineActivityCheckApi = exports.SessionVerifyStatusEnum = exports.AdminTicketShowStatusEnum = void 0;
/** 管理员门票展示状态（与服务端保持一致） */
var AdminTicketShowStatusEnum;
(function (AdminTicketShowStatusEnum) {
    AdminTicketShowStatusEnum["NOT_STARTED"] = "\u672A\u5F00\u59CB";
    AdminTicketShowStatusEnum["VERIFIED"] = "\u5DF2\u6838\u9500";
    AdminTicketShowStatusEnum["ENDED_UNVERIFIED"] = "\u5DF2\u7ED3\u675F\u672A\u6838\u9500";
})(AdminTicketShowStatusEnum || (exports.AdminTicketShowStatusEnum = AdminTicketShowStatusEnum = {}));
/** 策略会核销状态（与服务端 SessionVerifyStatus 对齐） */
var SessionVerifyStatusEnum;
(function (SessionVerifyStatusEnum) {
    /**
     * 未参与
     */
    SessionVerifyStatusEnum[SessionVerifyStatusEnum["NOT_PARTICIPATED"] = 0] = "NOT_PARTICIPATED";
    /**
     * 已参与 - 未开始核销
     */
    SessionVerifyStatusEnum[SessionVerifyStatusEnum["PARTICIPATED_NOT_VERIFIED"] = 1] = "PARTICIPATED_NOT_VERIFIED";
    /**
     * 已参与 - 待核销
     */
    SessionVerifyStatusEnum[SessionVerifyStatusEnum["PARTICIPATED_WAITING_VERIFIED"] = 2] = "PARTICIPATED_WAITING_VERIFIED";
    /**
     * 已参与 - 已核销
     */
    SessionVerifyStatusEnum[SessionVerifyStatusEnum["PARTICIPATED_VERIFIED"] = 3] = "PARTICIPATED_VERIFIED";
    /**
     * 已参与 - 已结束核销
     */
    SessionVerifyStatusEnum[SessionVerifyStatusEnum["PARTICIPATED_ENDED_VERIFIED"] = 4] = "PARTICIPATED_ENDED_VERIFIED";
})(SessionVerifyStatusEnum || (exports.SessionVerifyStatusEnum = SessionVerifyStatusEnum = {}));
class OfflineActivityCheckApi {
    constructor(actSign, module) {
        this.actSign = actSign;
        this.module = module;
        this.ticketType = 'offline-activity-ticket';
        this.sessionType = 'offline-activity-session';
        const { request } = require('@futuweb/fego-render').common;
        this.ticketApi = request.bindCommonApi(this.ticketType);
        this.sessionApi = request.bindCommonApi(this.sessionType);
    }
    /**
     * 从 URL 获取 uid 并格式化成 number。
     * 规则：解析失败（NaN）或等于 0 时，返回 -1。
     */
    getUidFromUrl() {
        const currentUrl = new URL(window.location.href);
        const searchUid = currentUrl.searchParams.get('uid');
        const hashQuery = currentUrl.hash.includes('?') ? currentUrl.hash.split('?')[1] : '';
        const hashUid = new URLSearchParams(hashQuery).get('uid');
        const rawUid = searchUid || hashUid || '';
        const uid = Number(rawUid);
        if (Number.isNaN(uid) || uid === 0) {
            return -1; // eslint-disable-line @typescript-eslint/no-magic-numbers
        }
        return uid;
    }
    /** 管理员获取指定用户门票信息 */
    async getAdminTicketInfo() {
        const res = await this.ticketApi.get('adminTicketInfo', {
            act_sign: this.actSign,
            module: this.module,
            uid: this.getUidFromUrl()
        });
        if (res.code !== 0) {
            throw new Error(res.message);
        }
        return res.data;
    }
    /** 管理员获取指定用户策略会信息 */
    async getAdminSessionDetail() {
        const res = await this.sessionApi.get('adminSessionDetail', {
            actSign: this.actSign,
            module: this.module,
            uid: this.getUidFromUrl()
        });
        if (res.code !== 0) {
            throw new Error(res.message);
        }
        return res.data;
    }
    /** 管理员给指定用户策略会核销 */
    async adminVerifySession(params) {
        const res = await this.sessionApi.post('adminVerifySession', Object.assign(Object.assign({ actSign: this.actSign, module: this.module }, params), { uid: this.getUidFromUrl() }));
        if (res.code !== 0) {
            throw new Error(res.message);
        }
        return res.data;
    }
}
exports.OfflineActivityCheckApi = OfflineActivityCheckApi;
//# sourceMappingURL=data:application/json;base64,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